// ABOUTME: Draws a DOM element into a canvas for a picture that leaves the app — a share card, an exported or
// ABOUTME: printed report: html2canvas at twice the size, CORS images allowed, always in the light theme.

import { inLightTheme } from "@shared/theme"

/** `backgroundColor: null` keeps the transparency (an overlay, a card with rounded corners). */
export async function captureElement(element: HTMLElement, backgroundColor: string | null): Promise<HTMLCanvasElement> {
  const { default: html2canvas } = await import("html2canvas-pro")
  return inLightTheme(() => html2canvas(element, { scale: 2, useCORS: true, allowTaint: true, backgroundColor }))
}
